import React from 'react';
import Chart, { Props as ChartProps } from 'react-apexcharts';
import { merge } from 'lodash';

const RadialChart = ({ options, ...props }: ChartProps): React.ReactElement => {
  return (
    <Chart
      type="radialBar"
      options={merge(
        {
          chart: {
            animations: { enabled: props.width === '100%' },
            fontFamily: 'futura-pt'
          },
          stroke: { lineCap: 'butt' },
          legend: { show: false }
        },
        options
      )}
      {...props}
    />
  );
};

export default RadialChart;
